import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Header from "../../partials/header";
import AddVoucher from "./addVoucher";
import ListVoucher from "./listVoucher";
import { styles } from "./styles";

// Component
class ServiceAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddVoucher: false,
    };
  }
  componentDidMount() {}

  addNewVoucher = () => {
    this.setState({ isAddVoucher: !this.state.isAddVoucher });
  };
  render() {
    const { t } = this.props;
    return (
      <div>
        {!this.state.isAddVoucher ? (
          <Header
            session={t("sidebar_promotion")}
            title={t("voucher_list_voucher")}
            button={t("voucher_add_new_voucher")}
            actionButton={this.addNewVoucher}
          />
        ) : (
          <>
            <Header
              session={t("voucher_list_voucher")}
              title={t("voucher_add_new_voucher")}
              backIcon={true}
              actionBack={() => this.addNewVoucher()}
            />
          </>
        )}
        {!this.state.isAddVoucher ? (
          <ListVoucher onRef={(id) => (this.ListVoucher = id)} />
        ) : (
          <AddVoucher createDone={this.addNewVoucher} />
        )}
      </div>
    );
  }
}

ServiceAdmin.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ServiceAdmin)
  )
);
